let html = `<div class="iframe">
    <div class="iframe__body">
        <iframe src="" class="iframe__window"></iframe>
    </div>
</div>`

export default html